import { render, staticRenderFns } from "./CreateOrderCard.vue?vue&type=template&id=adca2032&"
import script from "./CreateOrderCard.vue?vue&type=script&lang=js&"
export * from "./CreateOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderCard.vue?vue&type=style&index=0&id=adca2032&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports